namespace AgerLMS.Common {
    export interface PaymentCard {
        CardHolderName?: string;
        CardNumber?: string;
        ExpireMonth?: string;
        ExpireYear?: string;
        Cvc?: string;
        RegisterCard?: number;
    }
}
